import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { AdaptiveLearningContext } from '../types'
import {
  buildAdaptiveLearningQueryString,
  getAdaptiveLearningContext,
  getAdaptiveLearningContextFromLocation,
  isValidAdaptiveLearningContext,
} from '../utils/adaptiveLearningContext'

export const useAdaptiveLearningContext = () => {
  const location = useLocation<AdaptiveLearningContext>()

  return useMemo(() => {
    const context = getAdaptiveLearningContextFromLocation(location)

    return {
      context,
      queryString: buildAdaptiveLearningQueryString(context),
      isValid: isValidAdaptiveLearningContext(context),
      buildContext: (eventData?: AdaptiveLearningContext) =>
        getAdaptiveLearningContext(eventData, context),
    }
  }, [location])
}
